import React, { useEffect } from 'react';
import {
  EXPERIMENTS,
  isExperimentEnabled,
} from '@wix/communities-blog-client-common';
import { useSelector } from '../../../common/components/runtime-context';
import { WixRicosViewerLazy } from '../rich-content-viewer/wix-ricos-viewer-lazy';
import { WixRicosViewerNextLazy } from '../rich-content-viewer/wix-ricos-viewer-next-lazy';

const RichContentViewerLoader = () => {
  const rceNext = useSelector((state) =>
    isExperimentEnabled(state, EXPERIMENTS.USE_RCE_NEXT_OOI),
  );
  useEffect(() => {
    if (rceNext) {
      WixRicosViewerNextLazy.preload();
    } else {
      WixRicosViewerLazy.preload();
    }
  }, [rceNext]);

  return <React.Fragment />;
};

export default RichContentViewerLoader;
